import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {LastPage,AllInclusive,Add,MoreVert,Schedule,Block,Edit,Delete,Place} from '@material-ui/icons';


import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  LinearProgress,
  FormHelperText,
  CircularProgress
} from "@material-ui/core";

import { withLocalize,Translate } from "react-localize-redux";
import MUIDataTable from "mui-datatables";
import API from './api';

import { useSnackbar } from 'notistack';
import { setDayWithOptions } from 'date-fns/fp';

// import * as userInfo from "./login_info.js";

import UserInfo from "./login_info";

import axios from 'axios';

import {TransportService} from "./../../utils/web_config_2";


const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  btn:{
    textTransform:"capitalize",

  },
  formTitle:{
    flexGrow:1,
}
}));




function Stop() {
  const classes = useStyles1();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();


  const [operatorData, setOperatorData] = useState({});

  const [stopMessage,setStopMessage]=useState("No Stops available");


  // stop table 


const columns = [
  {
    name: "id",
    label: "id",
    options: {
      display:false,
     filter: true,
     sort: true,
    }
   },
  {
   name: "name",
   label: <Translate id="operator_stop.table.name" />,
   options: {
    filter: true,
    sort: true,
   }
  },
  {
   name: "description",
   label: <Translate id="operator_stop.table.description" />,
   options: {
    filter: true,
    sort: false,
   }
  },
  {
   name: "location",
   label: <Translate id="operator_stop.table.location" />,
   options: {
    filter: true,
    sort: false,
   }
  }, {
    name: "coordinates",
    label: <Translate id="operator_stop.table.coordinates" />,
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name:"currency",
    label: <Translate id="operator_stop.table.currency" />,
    options: {
     filter: true,
     sort: true,
    }
   }
 ];


 const options = {
  textLabels: {
    body: {
      noMatch: stopMessage
    },
  },
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:"single",
   rowsPerPage: 10,
   elevation:0,
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    <Box>
 

  <IconButton aria-label="Edit" onClick={()=>{
    var id=displayData[selectedRows.data[0]['index']]['data'][0];
    console.log("id",id);
    var obj=stops.find((item,i) => {
      return item.id == id;
  });

    console.log("====== obj ======", obj);

    setStopId({value:id,error:""});
    setName({value:obj.name,error:""});
    setDescription({value:obj.description,error:""});
    setCoordinates({value:obj.coordinates,error:""});
    setLocation({value:obj.location_id,error:""});
    setCurrency({value:obj.currency_id,error:""});
    setOpenEdit(true);
  }}>
  <Edit/>
  </IconButton>
  
 

      </Box>
  ),
 };



  // new stop dialog 

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(()=>{

    var data = {};
    const data1 = localStorage.getItem("nx_op");
    if (data1 != null) {
      data = JSON.parse(data1);
    }

    setOperatorData(data);
    axios.defaults.baseURL = new TransportService().BASE_URL;

    getStops(data.token);
    getProvinces(data.token);
    getDistricts(data.token);
    getCurrencies(data.token);

  },[]);

  // get stops

  const [loadStops,setLoadstops]=useState(false);
  const [stops,setStops]=useState([]);
  const getStops=(token)=>{
    const stopsInstance = axios.create(new TransportService().setHeaders(token));
    setLoadstops(true);
    stopsInstance.get("/api/v1/routePlaning/getStops?unpaged=true").then(res=>{
      setLoadstops(false);
      if(res.status==200){
        let s=res.data;
        s.sort((a, b)=>{    
          if (a['id'] < b['id']) {    
              return 1;    
          } else if (a['id'] > b['id']) {    
              return -1;    
          }    
          return 0;    
      } );
        if(s.length==0){
          setStopMessage("No Stops available");
        }
        const data=[];
        s.map((ss)=>{
          var obj={id:ss['id'],location_id:ss['location']['id'],name: ss['name'], description: ss['description'], location: ss['location']['name'],coordinates:ss['coordinates'],currency:ss['currency']?.['name'] || "Not set"};
          data.push(obj);
        })
        setStops(data);
      }
    }).catch(err=>{
      setLoadstops(false);
      if(err.message){
        enqueueSnackbar(err.message,
            { 
              variant: 'error'
          });
      }

      if(err.response){
        enqueueSnackbar(err.response.message,
            { 
              variant: 'error'
          });
      }
    })
  }

  // add new stop
  const [name,setName]=useState({value:"",error:""});
  const [description,setDescription]=useState({value:"",error:""});
  const [coordinates,setCoordinates]=useState({value:"",error:""});
  const [location,setLocation]=useState({value:0,error:""});
  const [currency,setCurrency]=useState({value:0,error:""});
  const [addStopLoad,setAddStopLoad]=useState(false);

  const addStop=()=>{
    if(name.value===""){
      setName({value:"",error:"Enter stop name"});
    }else if(description.value===""){
      setDescription({value:"",error:"Enter dscription"});
    }else if(coordinates.value===""){
      setCoordinates({value:"",error:"Enter coordinates"})
    }else if(location.value===0){
      setLocation({value:0,error:"Select district"});
    }
     else if(currency.value===0){
      setCurrency({value:0,error:"Select currency"});
    }
    else{
      axios.defaults.baseURL = new TransportService().BASE_URL;
      const addInstance = axios.create(new TransportService().setHeaders(operatorData.token));
      setAddStopLoad(true);
      addInstance.post("/api/v1/routePlaning/addStop",{
        "coordinates": coordinates.value,
        "location_id": location.value,
        "name": name.value,
        "organization_id": new UserInfo().ORG_ID,
        "status": "ACTIVE",
        "currency_id":currency.value,
      }).then(res=>{
        var o=res.data;
        var obj={id:o['id'],location_id:o['location']['id'],name: o['name'], description: o['description'], location: o['location']['name'],coordinates:o['coordinates'],currency:o['currency']?.['name']};
        var objs=stops;
        objs.unshift(obj);
        setStops(objs);
         
        setAddStopLoad(false);
        if(res.status==201){
          setOpen(false);
          enqueueSnackbar('Stop added successful!',
          { 
            variant: 'success'
        });
        // getStops(operatorData.token);
        }
      })
      .catch(err=>{
        setAddStopLoad(false);
        if(err.response.status==500){
          enqueueSnackbar("Stop name is already taken!",
            { 
              variant: 'error'
          });
        }
      });
    }
  }

  // get province

const [provinceId,setProvinceId]=useState({value:"",error:""});
const [provinces,setProvinces]=useState([]);
const getProvinces=(token)=>{
  const provinceInstance = axios.create(new TransportService().setHeaders(token));
  provinceInstance.get("/api/v1/locations/findLocationsByLevel/2").then(res=>{
  if(res.status==200){
    setProvinces(res.data);
  }
})
}

// get district

const [districts,setDistricts]=useState([]);
const getDistricts=(token)=>{
  const districtInstance = axios.create(new TransportService().setHeaders(token));
  districtInstance.get("/api/v1/locations/findLocationsByLevel/3").then(res=>{
    if(res.status==200){
      setDistricts(res.data);
    }
  }) 
}

const [currencies,setCurrencies]=useState([]);
const getCurrencies=(token)=>{
  const currencyInstance = axios.create(new TransportService().setHeaders(token));
  currencyInstance.get("/api/v1/currencies/getCurrencys").then(res=>{
    if(res.status==200){
      setCurrencies(res.data);
    }
  }
  )
}


// filter district 

const [filterDistrict,setFilterDistrict]=useState([]);
const FilterDistrict=(id)=>{
setFilterDistrict(districts.filter((d)=>d['parent']['id']==id));
}



// edit stop dialog
const [openEdit,setOpenEdit]=useState(false);
const [stopId,setStopId]=useState({value:0,error:""});
const [editStopStatus,setEditStopStatus]=useState({load:false,status:false});
const editStop=()=>{
  if(name.value===""){
    setName({value:"",error:"Enter stop name"});
  }else if(description.value===""){
    setDescription({value:"",error:"Enter dscription"});
  }else if(coordinates.value===""){
    setCoordinates({value:"",error:"Enter coordinates"})
  }else if(location.value===0){
    setLocation({value:0,error:"Select district"});
  }
  else if(currency.value===0){
    setCurrency({value:0,error:"Select currency"});
  }
  else{

    axios.defaults.baseURL = new TransportService().BASE_URL;
    const modifyInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    setEditStopStatus({load:true,status:false});

    modifyInstance.put("/api/v1/routePlaning/modifyStop",
    {
      "coordinates": coordinates.value,
      "description": description.value,
      "id": stopId.value,
      "location_id": location.value,
      "name": name.value,
      "organization_id": new UserInfo().ORG_ID,
      "currency_id":currency.value,
      "status": "ACTIVE"
    }).then(res=>{
      var index=stops.findIndex((v)=>v.id==stopId.value);
      var o=res.data;
      var obj={id:o['id'],location_id:o['location']['id'],name: o['name'], description: o['description'], location: o['location']['name'],coordinates:o['coordinates'],currency:o['currency']
      ?o['currency']['name']:"Not set"
      };
      var objs=stops;
      objs[index]=obj;
      setStops(objs);

      setEditStopStatus({load:false,status:false});
      console.log(res);
      console.log(res.data);
      if(res.status===200){
        setEditStopStatus({load:false,status:true});
        enqueueSnackbar('Stop updated successful!',
          { 
            variant: 'success'
        });
        setOpenEdit(false);
        // getStops(operatorData.token);
      }
    }).catch(err=>{
      setEditStopStatus({load:false,status:false});

     console.log(err.response.data);

        if(err.response.status==400){
          enqueueSnackbar("Invalid Stop!",
            { 
              variant: 'error'
          });
        }
    })
  }
}



  return (
    <div className={classes.root}>
      <Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}><Place fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b>Stops</b></Typography>

 </Box>
 
 
<Button  
className={classes.btn}
size="small"
startIcon={<Add/>} 
onClick={()=>{handleClickOpen()}} 
variant="contained" 
color="primary"
disableElevation={true}>

<Typography noWrap>New stop</Typography>
</Button>
 
     </Box>

 {/* stops table  */}

 <Box mt={2}>
 {loadStops&&<LinearProgress />}
 <MUIDataTable
  title={"Stops list"}
  data={stops}
  columns={columns}
  options={options}
/>
 </Box> 

{/* dialog new stop  */}

    <Dialog
    maxWidth="sm"
    fullWidth
        open={open}
        onClose={handleClose}
        aria-labelledby="new branch"
        aria-describedby="new bramnch"
      >
        <DialogTitle id="new branch">{"New Stop"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
             
          <Box display='flex' alignItems='center' justifyContent='center'>
            <TextField size='small' variant='outlined' label="Stop name" onChange={(e)=>{
              if(e.target.value===""){
                setName({value:"",error:"Enter stop name"});
              }else{
                setName({value:e.target.value,error:""});
              }
            }}  color='primary'
            error={name.error!==""}
            helperText={name.error}
            fullWidth    /></Box>


          <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                 <InputLabel htmlFor="location">Select province</InputLabel>
        <Select
        size="small"
        helperText={"error"} 
        label="Select level"
        inputProps={{
          name: 'level',
          id: 'level',
        }}
        error={provinceId.error!==""}
        onChange={(e)=>{
          if(e.target.value===""){
            setProvinceId({value:"",error:"Select province"});
          }else{
            setProvinceId({value:e.target.value,error:""});
            FilterDistrict(e.target.value);
          }
        }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {
            provinces.map((p)=>{
            return <MenuItem value={p['id']}>{p['name']}</MenuItem>
            })
          }
        </Select>
        <FormHelperText error={provinceId.error!==""}>{provinceId.error}</FormHelperText>
      </FormControl>


</Box>


          <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                 <InputLabel htmlFor="district">Choose district</InputLabel>
        <Select
        size="small"
        helperText={"error"} 
        label="Select district"
        inputProps={{
          name: 'disctrict',
          id: 'district',
        }}

        error={location.error!==""}
        onChange={(e)=>{
          if(e.target.value===""){
            setLocation({value:0,error:"Select district"});
          }else{
            setLocation({value:e.target.value,error:""});
            console.log(e.target.value);
          }
        }}
        
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          { 
            filterDistrict.map((d)=>{
                return <MenuItem value={d['id']}>{d['name']}</MenuItem>;
              }
            )
          }
        </Select>
        <FormControl error={location.error!==""}>{location.error}</FormControl>
      </FormControl>


</Box>

<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
  <TextField size='small' variant='outlined' label="Coordinates"
  onChange={(e)=>{
    if(e.target.value===""){
      setCoordinates({value:"",error:"Enter coordinates"});
    }else{
      setCoordinates({value:e.target.value,error:""});
    }
  }}
  error={coordinates.error!==""}
  helperText={coordinates.error}
  color='primary'
    fullWidth/></Box>

    <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                  <InputLabel htmlFor="currency">Select currency</InputLabel>
        <Select
        size="small"
        helperText={"error"}
        label="Select currency"
        inputProps={{
          name: 'currency',
          id: 'currency',
        }}
        error={currency.error!==""}
        onChange={(e)=>{
          if(e.target.value===""){
            setCurrency({value:0,error:"Select currency"});
          }else{
            setCurrency({value:e.target.value,error:""});
          }
        }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {
            currencies.map((c)=>{
            return <MenuItem value={c['id']}>{c['name']}</MenuItem>
            })
          }
        </Select>
        <FormHelperText error={currency.error!==""}>{currency.error}</FormHelperText>
      </FormControl>
</Box>


          

<Box mt={1}>
    <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  
<TextareaAutosize
fullWidth
      rows={10}
      aria-label="Description"
      placeholder="Description"
      onChange={(e)=>{
        if(e.target.value===""){
          setDescription({value:"",error:"Enter description"});
        }else{
          setDescription({value:e.target.value,error:""});
        }
      }}
      error={description.error!==""}
      helperText={description.error}
    />
     </FormControl>
</Box>       
            
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          
          <Button onClick={handleClose} color="secondary" variant="outlined" >
            Cancel
          </Button>
          <Button disableElevation disabled={addStopLoad} onClick={addStop} variant="contained" color="primary" >
        {addStopLoad?<CircularProgress size={25} color="secondary" />:"Save"}
          </Button>
        </DialogActions>
      </Dialog>



 {/* edit stop  */}




 <Dialog
    maxWidth="sm"
    fullWidth
        open={openEdit}
        onClose={()=>{
          setOpenEdit(false)
        }}
        aria-labelledby="new branch"
        aria-describedby="new bramnch"
      >
        <DialogTitle id="edit branch">{"Edit Stop"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
             
          <Box display='flex' alignItems='center' justifyContent='center'>
            <TextField size='small' variant='outlined' label="Stop name" value={name.value} onChange={(e)=>{
              if(e.target.value===""){
                setName({value:"",error:"Enter stop name"});
              }else{
                setName({value:e.target.value,error:""});
              }
            }}  color='primary'
            error={name.error!==""}
            helperText={name.error}
            fullWidth    /></Box>


          <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                 <InputLabel htmlFor="location">Select province</InputLabel>
        <Select
        size="small"
        helperText={"error"} 
        label="Select level"
        inputProps={{
          name: 'level',
          id: 'level',
        }}
        error={provinceId.error!==""}
        onChange={(e)=>{
          if(e.target.value===""){
            setProvinceId({value:"",error:"Select province"});
          }else{
            setProvinceId({value:e.target.value,error:""});
            FilterDistrict(e.target.value);
          }
        }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {
            provinces.map((p)=>{
            return <MenuItem value={p['id']}>{p['name']}</MenuItem>
            })
          }
        </Select>
        <FormHelperText error={provinceId.error!==""}>{provinceId.error}</FormHelperText>
      </FormControl>


</Box>


          <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                 <InputLabel htmlFor="district">Choose district</InputLabel>
        <Select
        size="small"
        helperText={"error"} 
        label="Select district"
        inputProps={{
          name: 'disctrict',
          id: 'district',
        }}

        error={location.error!==""}
        onChange={(e)=>{
          console.log(e.target.value);
          if(e.target.value===""){
            setLocation({value:0,error:"Select district"});
          }else{
            setLocation({value:e.target.value,error:""});

            
          }
        }}
        
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          { 
            filterDistrict.map((d)=>{
                return <MenuItem value={d['id']}>{d['name']}</MenuItem>;
              }
            )
          }
        </Select>
        <FormControl error={location.error!==""}>{location.error}</FormControl>
      </FormControl>


</Box>

<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
  <TextField size='small' variant='outlined' label="Coordinates"
  value={coordinates.value}
  onChange={(e)=>{
    if(e.target.value===""){
      setCoordinates({value:"",error:"Enter coordinates"});
    }else{
      setCoordinates({value:e.target.value,error:""});
    }
  }}
  error={coordinates.error!==""}
  helperText={coordinates.error}
  color='primary'
    fullWidth/></Box>
    
    <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                  <InputLabel htmlFor="currency">Select currency</InputLabel>
        <Select
        size="small"
        helperText={"error"}
        label="Select currency"
        inputProps={{
          name: 'currency',
          id: 'currency',
        }}
        error={currency.error!==""}
        onChange={(e)=>{
          if(e.target.value===""){
            setCurrency({value:0,error:"Select currency"});
          }else{
            setCurrency({value:e.target.value,error:""});
          }
        }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {
            currencies.map((c)=>{
            return <MenuItem value={c['id']}>{c['name']}</MenuItem>
            })
          }
        </Select>
        <FormHelperText error={currency.error!==""}>{currency.error}</FormHelperText>
      </FormControl>
</Box>

<Box mt={1}>
    <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  
<TextareaAutosize
fullWidth
      rows={10}
      aria-label="Description"
      placeholder="Description"
      onChange={(e)=>{
        if(e.target.value===""){
          setDescription({value:"",error:"Enter description"});
        }else{
          setDescription({value:e.target.value,error:""});
        }
      }}
      error={description.error!==""}
      helperText={description.error}
      value={description.value}
    />
     </FormControl>
</Box>       
            
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          
          <Button onClick={()=>{
            setOpenEdit(false);
          }} color="secondary" variant="outlined" >
            Cancel
          </Button>
          <Button disableElevation onClick={editStop} variant="contained" color="primary" autoFocus>
        {editStopStatus.load?<CircularProgress size={25} color="secondary" />:"Save changes"}
          </Button>
        </DialogActions>
      </Dialog>



    </div>
  );
}

export default  withLocalize(Stop);